/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Task_2Inputs */

const en_mk_tb_example_task_2 = /** @type {(inputs: Mk_Tb_Example_Task_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check project permissions`)
};

const id_mk_tb_example_task_2 = /** @type {(inputs: Mk_Tb_Example_Task_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periksa izin akses proyek`)
};

/**
* | output |
* | --- |
* | "Check project permissions" |
*
* @param {Mk_Tb_Example_Task_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_task_2 = /** @type {((inputs?: Mk_Tb_Example_Task_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Task_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_task_2(inputs)
	return en_mk_tb_example_task_2(inputs)
});